import { FC } from 'react';
import { Add } from '@carbon/react/icons';
import { Button } from '@carbon/react';
import { useHistory } from 'react-router-dom';
import routes from '~/routes';
import { PageHeader } from 'components/page-header';
import DifferentialScenariosContent from './differential-scenarios-content';

/**
 * Entry page for the Oil & Gas Differentials catalog/list.
 * @return {JSX.Element} The list page
 */
const DifferentialScenariosPage: FC = () => {
  const history = useHistory();

  return (
    <>
      <PageHeader
        breadcrumbs={[]}
        title="Oil & Gas Differentials"
        actions={
          <Button
            renderIcon={Add}
            kind="primary"
            onClick={() => history.push(routes.newDifferentialScenarioPath)}
          >
            Create Differential Scenario
          </Button>
        }
      />
      <DifferentialScenariosContent />
    </>
  );
};

export { DifferentialScenariosPage };
